export default __webpack_public_path__ + "static/media/money-back@2x.a15c2bc1.png";